/* src/app/shared/slide-panel/slide-panel-host.component.scss */
:host {
  display: block;
  position: fixed;
  top: var(--header-height);
  right: 0;
  bottom: 0;
  z-index: 10;
  pointer-events: none;
}
.slide-panel {
  pointer-events: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--mat-sidenav-container-background-color, #fff);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.slide-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  min-height: 52px;
  padding: 0 8px 0 16px;
  border-bottom: 1px solid var(--idl-color-border, #e0e0e0);
}
.slide-panel-title {
  font-size: 1rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.slide-panel-close {
  flex-shrink: 0;
}
.slide-panel-body {
  flex: 1;
  overflow: auto;
  min-height: 0;
  padding: var(--spacing-md);
}
/*# sourceMappingURL=slide-panel-host.component.css.map */
